<script setup lang="ts">
import { Form } from '~/layers/forms/models'

interface Props {
  identifier?: Form | string
  cols?: number
}

const props = withDefaults(defineProps<Props>(), {
  identifier: undefined,
  cols: 3,
})

const id = computed(() => {
  const identifiers: (Form | string | undefined)[] = Object.values(Form)
  if (identifiers.includes(props.identifier)) {
    return `${props.identifier}-form`
  }

  return props.identifier
})
</script>

<template>
  <GridComponent
    :id
    v-slot="{ classGetter }"
    :cols
    :min-cols="1"
  >
    <slot :section-classes="classGetter" />
  </GridComponent>
</template>
